import classNames from "classnames";
import { Swiper } from "antd-mobile";
import { getImg, pxChangeVw } from "@/utils";
import { homeAtom } from "@/atoms/home";
import slideDistance from "@/utils/slideDistance";
import BaseContent from "@/components/HomeMain/Default/VendorLayout/BaseContent";

const WarningTips: React.FC = () => {
  const navigate = useNavigate();

  const homeData = useAtomValue(homeAtom);
  const current = homeData?.data?.current ?? {};
  // 创建 refs 来存储需要动画的元素
  const textRefs = useRef<Record<string, HTMLDivElement | null>>({});

  const handleAlert = (_item: any) => {
    return () => {
      if (!window?.AndroidInterface?.getOnClient) {
        console.log("isAppCalendarDomain", _item);
        navigate("/home/detail", {
          state: { expandId: _item.AlertID },
        });
      }
    };
  };

  // 应用滑动动画
  const applySlideAnimation = (refs: any) => {
    Object.values(refs).forEach((element: any) => {
      if (element) {
        slideDistance({
          speed: 0.01,
          end: element.parentElement?.clientWidth - element.clientWidth,
        })(element);
      }
    });
  };

  useEffect(() => {
    // 在组件挂载后应用动画
    applySlideAnimation(textRefs.current);
  }, []);

  return (
    !!current?.warnings?.length && (
      <BaseContent
        className={classNames(["rounded-10 backdrop-blur-10 h-50 overflow-hidden relative p-0 bg-[var(--app-bg-08)]"])}
      >
        <div className="w-full overflow-hidden relative">
          <div className="p-0 relative">
            <div>
              <img
                src={getImg("more@2x.png")}
                alt=""
                className="w-14 h-14 absolute right-10 top-50% translate-y-[-50%]"
              />
            </div>
            <div className="overflow-hidden relative h-50">
              <ul className="relative top-0 p-0 m-0">
                <Swiper
                  direction="vertical"
                  autoplay
                  loop
                  autoplayInterval={3000}
                  indicator={() => null}
                  // @ts-ignore
                  style={{ "--height": pxChangeVw("50px") }}
                  // @ts-ignore
                  onSlideChange={() => {
                    // 当幻灯片切换时重新应用动画
                    setTimeout(() => {
                      applySlideAnimation(textRefs.current);
                    }, 100);
                  }}
                >
                  {current.warnings.map((item: any, index: number) => {
                    const concatString =
                      item?.Description?.Localized +
                      ":" +
                      " " +
                      item?.detail?.start +
                      "-" +
                      item?.detail?.end +
                      "," +
                      item?.detail?.Summary;
                    return (
                      <Swiper.Item key={index} onClick={handleAlert(item)}>
                        <li className="h-50 lh-50 overflow-hidden pr-10">
                          <a
                            className="color-[var(--app-text-04)] decoration-none block w-full h-full pr-34"
                            onClick={e => {
                              e.preventDefault();
                            }}
                            rel="noreferrer"
                          >
                            <div
                              // @ts-ignore
                              style={{ "--data-color": item?.Color?.Hex }}
                              className='float-left w-full  overflow-hidden whitespace-nowrap text-ellipsis flex items-center justify-start gap-x-8 before:content-[""] before:w-5 before:h-50 before:inline-block before:align-bottom before:bg-[var(--data-color)]'
                            >
                              <SvgIcon name="svg09" color={item?.Color?.Hex} />
                              <div className="overflow-hidden w-[calc(100%-40px)]">
                                <div
                                  className={classNames([
                                    "inline-block whitespace-nowrap px-4 py-0 font-[Roboto_Light] font-size-inherit",
                                  ])}
                                  ref={el => (textRefs.current[index] = el)}
                                >
                                  {concatString}
                                </div>
                              </div>
                            </div>
                          </a>
                        </li>
                      </Swiper.Item>
                    );
                  })}
                </Swiper>
              </ul>
            </div>
          </div>
        </div>
      </BaseContent>
    )
  );
};
export default WarningTips;
